import { TextLabel } from '@core/components/Inputs';
import { formatTELEFONE } from '@format';
import { Grid } from '@material-ui/core';
import React from 'react';

const EnderecoVisualizar = ({ contato }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextLabel label="Nome do contato" value={contato && contato[0]?.nomeReferencia} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="Telefone principal" value={contato && contato[0]?.numero} format={formatTELEFONE} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel label="E-mail principal" value={contato && contato[0]?.email} />
      </Grid>

      <Grid item xs={6}>
        <TextLabel
          label="Telefones adicionais"
          id="telefones"
          value={contato && contato[0]?.telefonesAdicionais}
          map="numero"
          format={formatTELEFONE}
        />
      </Grid>

      <Grid item xs={6}>
        <TextLabel id="emails" label="E-mails adicionais" value={contato && contato[0]?.emailsAdicionais} map="email" />
      </Grid>
    </Grid>
  );
};

export default EnderecoVisualizar;
